import { type DestinationCarte, EVENEMENT_CENTRER_CARTE } from '@carte/contrats/recherche';

/**
 * Lieu (commune ou adresse) choisi dans la palette et à montrer sur la carte.
 *
 * Deux canaux, car la carte peut ne pas être encore montée quand on choisit un lieu depuis une autre page :
 * - un événement `window` (`EVENEMENT_CENTRER_CARTE`) si la carte est déjà affichée ;
 * - une destination en attente, que la carte lit à son montage avec `consommerDestination()`.
 */
let enAttente: DestinationCarte | null = null;

export function demanderCentrage(destination: DestinationCarte): void {
  enAttente = destination;
  window.dispatchEvent(new CustomEvent<DestinationCarte>(EVENEMENT_CENTRER_CARTE, { detail: destination }));
}

/** Lit et efface la destination en attente (à appeler au montage de la carte). */
export function consommerDestination(): DestinationCarte | null {
  const destination = enAttente;
  enAttente = null;
  return destination;
}

/** Lit la destination en attente sans l'effacer (sûr en double rendu ; effacer ensuite avec `oublierDestination`). */
export function lireDestination(): DestinationCarte | null {
  return enAttente;
}

/** À appeler quand la carte a traité l'événement, pour ne pas rejouer la destination au prochain montage. */
export function oublierDestination(): void {
  enAttente = null;
}
